import { render, staticRenderFns } from "./GeneralGroupDataCounters.vue?vue&type=template&id=59086c56&scoped=true&"
import script from "./GeneralGroupDataCounters.vue?vue&type=script&lang=js&"
export * from "./GeneralGroupDataCounters.vue?vue&type=script&lang=js&"
import style0 from "./GeneralGroupDataCounters.vue?vue&type=style&index=0&id=59086c56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59086c56",
  null
  
)

export default component.exports